import React, { useState, useEffect } from 'react';
import Title from '../Utils/Headers/Title';
import './notification-config.css';

export const NotificationConfigView = ({ config, loading, onUpdate, onToggle, onTest }) => {
    const [jsonCreds, setJsonCreds] = useState('');
    const [serverKey, setServerKey] = useState('');
    const [testTitle, setTestTitle] = useState('Prueba de Sistema');
    const [testBody, setTestBody] = useState('Esta es una notificación de prueba para verificar la configuración.');

    useEffect(() => {
        if (config) {
            setJsonCreds(JSON.stringify(config.firebase_credentials || {}, null, 2));
            setServerKey(config.server_key || '');
        }
    }, [config]);

    const handleSave = () => {
        try {
            const parsedCreds = JSON.parse(jsonCreds);
            onUpdate({
                firebase_credentials: parsedCreds,
                server_key: serverKey
            });
        } catch (e) {
            alert('El JSON de credenciales no es válido');
        }
    };

    const handleTest = () => {
        onTest({
            title: testTitle,
            body: testBody
        });
    };

    const isEnabled = config && config.is_enabled;

    return (
        <div className='card pb-3 mb-5'>
            <div className="px-4 pt-4 container-title-create">
                <Title
                    textWhite={true}
                    title={"Configuración de Notificaciones"}
                    subtitle={"Administración"}
                    showCreate={false}
                />
            </div>

            <div className="p-0 px-3 pt-3 notif-config-page">

                {/* ── Estado del servicio ─────────────────────────────── */}
                <div className="notif-config-section">
                    <div className="notif-section-title">
                        <span className="material-icons">settings</span>
                        Estado del Servicio
                    </div>

                    <div className="notif-status-row">
                        <span className="notif-status-label">Estado del servicio</span>

                        <label className="notif-toggle">
                            <input
                                type="checkbox"
                                checked={isEnabled || false}
                                onChange={onToggle}
                            />
                            <div className="notif-toggle-track">
                                <div className="notif-toggle-thumb" />
                            </div>
                            <span className={`notif-toggle-badge ${isEnabled ? 'active' : 'inactive'}`}>
                                {isEnabled ? 'Activado' : 'Desactivado'}
                            </span>
                        </label>
                    </div>

                    <p className="notif-status-description">
                        Controla si se envían notificaciones push globalmente.
                    </p>
                </div>

                {/* ── Credenciales Firebase ───────────────────────────── */}
                <div className="notif-config-section">
                    <div className="notif-section-title">
                        <span className="material-icons">vpn_key</span>
                        Credenciales de Firebase (JSON Service Account)
                    </div>

                    <textarea
                        className="notif-json-area"
                        rows={10}
                        value={jsonCreds}
                        onChange={(e) => setJsonCreds(e.target.value)}
                        placeholder='{ "type": "service_account", ... }'
                        spellCheck={false}
                    />
                    <p className="notif-json-hint">
                        Pegue aquí el contenido del archivo JSON de la cuenta de servicio de Firebase.
                    </p>

                    <div className="notif-btn-row">
                        <button
                            className="notif-btn-save"
                            onClick={handleSave}
                            disabled={loading}
                        >
                            <span className="material-icons" style={{ fontSize: 16 }}>save</span>
                            Guardar configuración
                        </button>
                    </div>
                </div>

                {/* ── Prueba de notificación ──────────────────────────── */}
                <div className="notif-config-section">
                    <div className="notif-section-title">
                        <span className="material-icons">send</span>
                        Prueba de notificación
                    </div>

                    <div className="notif-test-grid">
                        <div>
                            <label className="notif-field-label">Título</label>
                            <input
                                type="text"
                                className="notif-text-input"
                                value={testTitle}
                                onChange={(e) => setTestTitle(e.target.value)}
                                placeholder="Prueba de Sistema"
                            />
                        </div>
                        <div>
                            <label className="notif-field-label">Mensaje</label>
                            <input
                                type="text"
                                className="notif-text-input"
                                value={testBody}
                                onChange={(e) => setTestBody(e.target.value)}
                                placeholder="Esta es una notificación de prueba para verificar la configuración."
                            />
                        </div>
                    </div>

                    <div className="notif-btn-row" style={{ alignItems: 'center', gap: 12 }}>
                        {!isEnabled && (
                            <span className="notif-disabled-warning">
                                <span className="material-icons" style={{ fontSize: 14 }}>warning</span>
                                Active las notificaciones para realizar pruebas.
                            </span>
                        )}
                        <button
                            className="notif-btn-test"
                            onClick={handleTest}
                            disabled={loading || !isEnabled}
                        >
                            <span className="material-icons" style={{ fontSize: 16 }}>send</span>
                            Enviar prueba a mi dispositivo
                        </button>
                    </div>
                </div>

            </div>
        </div>
    );
};
